import React from "react";
import { Link } from "react-router-dom";
import "./HealBidBrand.scss";

/** Same asset as doctor sidebar / auth (`public/Assets/logo.png` at runtime). */
const BRAND_LOGO_SRC = "/Assets/logo.png";

/**
 * Full wordmark in the patient app bar (desktop); compact height on narrow viewports.
 * @param {{ markOnly?: boolean }} markOnly — tighter max dimensions when the shell shares the bar with a centered title.
 */
export default function HealBidBrand({ to = "/HealBidDashboard", className = "", markOnly = false }) {
  return (
    <Link
      to={to}
      className={`hbBrand${markOnly ? " hbBrand--compact" : ""} ${className}`.trim()}
      aria-label="HealBid home"
    >
      <img src={BRAND_LOGO_SRC} alt="" className="hbBrand__img" />
    </Link>
  );
}
